// Framework
import Vue from 'vue'
import Router from 'vue-router'

// Public/Auth
import Login from '@/views/public/Login.vue'
import Logout from '@/views/public/Logout.vue'

// Dashboard
import Dashboard from '@/views/private/Dashboard.vue'

// Production
import ProductionV2 from '@/views/private/production/Production_v2.vue'
import ProductionV3 from '@/views/private/production/Production_v3.vue'
import EmbroideryV1 from '@/views/private/production/Embroidery_v1.vue'
import ProductionItemV2 from '@/views/private/production/ProductionItem_v2.vue'
import PhotoZippoDetails from '@/views/private/production/PhotoZippoZakeke.vue'
import PhotoKeychain from '@/views/private/production/PhotoKeychain.vue'
import PhotoKeychainAmazon from '@/views/private/production/PhotoKeychainAmazon.vue'
import PhotoZippoAmazon from '@/views/private/production/PhotoZippoAmazon.vue'
import BabyCubeDetails from '@/views/private/production/BabyCubeDetails2.vue'
import DateKeyChainDetails from '@/views/private/production/DateKeyChainDetails.vue'
import VictorinoxDetails from '@/views/private/production/VictorinoxDetails.vue'
import Laser from '@/views/private/LaserHistory.vue'
import ProductionTime from '@/views/private/ProductionTime.vue'

// Shipping & Packlists
import PacklistsV2 from '@/views/private/shipping/Packlists.vue'
import PacklistRootOld from '@/views/private/packlistTidied/PacklistRoot.vue'
import PacklistRoot from '@/views/private/shipping/packlist/PacklistRoot.vue'
import PacklistItemFinder from '@/views/private/packlist_v2/PacklistItemFinder.vue'
import MulticartWizard from '@/views/private/shipping/multicart/MulticartWizard.vue'
import MulticartPlacement from '@/views/private/warehouse/shelfPlacement/MulticartPlacement.vue'
import ShippingRulesManager from '@/views/private/ShippingRulesManager.vue'
import PackHistory from '@/views/private/PackHistory.vue'
import PackagingRoot from '@/views/private/packaging/PackagingRoot.vue'
import PackageListGenerator from '@/views/private/PackageListGenerator.vue'
import PrimeCutOffManager from '@/views/private/primecutoff/PrimeCutOffManager.vue'
import CutoffMonitor from '@/views/private/cutoff/CutoffMonitor.vue'

// Warehouse
import Warehouse from '@/views/private/Warehouse.vue'
import MultiCartShelfManager from '@/views/private/warehouse/shelfManagement/MultiCartShelfManager.vue'
import SkuManagement from '@/views/private/warehouse/skuManagement/skuManagement.vue'
import InventoryWorth from '@/views/private/InventoryWorth.vue'
import WarehouseTaskChoice from '@/views/private/warehouse/warehouseTaskChoice/warehouseTaskChoice.vue'

// Support & Customer Service
import Support from '@/views/private/Support.vue'
import CustomerSupport from '@/views/private/customerSupport/CustomerSupport.vue'

// Returns & Damaged Items
import Damaged from '@/views/private/Damaged.vue'
import RetoureV2 from '@/views/private/Retoure/RetoureV2.vue'

// Utilities & Tools
import TimeTracking from '@/views/private/TimeTracking.vue'
import BarcodeGenerator from '@/views/private/BarcodeGenerator.vue'
import ExternalInstructions from '@/views/private/ExternalInstructions.vue'
import FailedLabels from '@/views/private/FailedLabels.vue'
import FailedLabelDetails from '@/views/private/FailedLabelDetails.vue'

// Admin Features
import AdminDashboard from '@/views/private/AdminDashboard.vue'
import EnhancedAdminDashboard from '@/views/private/admin/EnhancedAdminDashboard.vue'
import UserManagement from '@/views/private/UserManagement.vue'
import PrinterManagement from '@/views/private/PrinterManagement.vue'
import KeyAssignment from '@/views/private/admin/KeyAssignment.vue'

// Embroidery Management
import EmbroideryShelf from '@/views/private/embroidery/EmbroideryShelf.vue'
import EmbroideryProducts from '@/views/private/embroidery/EmbroideryProducts.vue'

// Importers
import MuckelMeisterImporter from '@/views/private/importer/MuckelMeisterImporter.vue'
import EtsyMuckelmeisterImporter from '@/views/private/importer/EtsyMuckelmeisterImporter.vue'
import ImporterMonitor from '@/views/private/importer/ImporterMonitor.vue'

// Messaging
import MessageInbox from '@/views/private/messaging/MessageInbox.vue'
import AdminMessageCenter from '@/views/private/messaging/AdminMessageCenter.vue'

// Packlist Alerts
import PacklistAlertManager from '@/views/private/packlistAlerts/PacklistAlertManager.vue'

// Other
import SlaRulesManager from '@/views/private/SlaRulesManager.vue'

Vue.use(Router)

// Helper function to detect small device
function isSmallDevice() {
  return window.innerWidth <= 480;
}

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: "/auth/login",
      name: "Login",
      component: Login,
      meta: { allowSmallDevice: true }
    },
    {
      path: "/auth/logout",
      name: "Logout",
      component: Logout
    },

    {
      path: '/dashboard',
      name: 'Dashboard',
      component: Dashboard
    },
    {
      path: '/damaged',
      name: 'Fehlproduktionen',
      component: Damaged
    },
    {
      path: '/retoure',
      name: 'Retouren',
      component: RetoureV2
    },
    {
      path: '/v2/production',
      name: 'ProductionV2',
      component: ProductionV2
    },
    {
      path: '/v3/production',
      name: 'ProductionV3',
      component: ProductionV3
    },
    {
      path: '/v1/embroidery/:table',
      name: 'EmbroideryV1',
      component: EmbroideryV1
    },
    {
      path: '/laser',
      name: 'Laser',
      component: Laser
    },
    {
      path: '/packhistory',
      name: 'PackHistrory',
      component: PackHistory
    },
    {
      path: '/production/:name',
      name: 'ProductionItem',
      component: ProductionItemV2
    },

    {
      path: '/production/photozippo/details',
      name: 'PhotoZippoDetails',
      component: PhotoZippoDetails
    },
    {
      path: '/production/keychain_photo/details',
      name: 'PhotoKeychain',
      component: PhotoKeychain
    },
    {
      path: '/production/keychain_picture/details',
      name: 'PhotoKeychainAmazon',
      component: PhotoKeychainAmazon
    },
    {
      path: '/production/photozippo_amz/details',
      name: 'PhotoZippoAmazon',
      component: PhotoZippoAmazon
    },
    {
      path: '/production/babycube/details',
      name: 'BabyCubeDetails',
      component: BabyCubeDetails
    },
    {
      path: '/production/datekeychain/details',
      name: 'DateKeyChainDetails',
      component: DateKeyChainDetails
    },
    {
      path: '/production/victorinox/details',
      name: 'VictorinoxDetails',
      component: VictorinoxDetails
    },
    {
      path: '/packlistsV2',
      name: 'Packlists V2',
      alias: '/',
      component: PacklistsV2
    },
    {
      path: '/packlistV2/:id',
      name: 'Packlist V2',
      component: PacklistRootOld
    },
    {
      path: '/packlistV3/:id',
      name: 'Packlist Details V3',
      component: PacklistRoot
    },
    {
      path: '/packlistFinder',
      name: 'Packlist Finder',
      component: PacklistItemFinder
    },
    {
      path: '/warehouse',
      name: 'Warehouse',
      component: Warehouse,
      meta: {
        requiresAuth: true,
        requiresAdmin: false
      }
    },
    {
      path: '/warehouse/sku-management',
      name: 'SkuManagement',
      component: SkuManagement,
      meta: {
        requiresAuth: true,
        requiresAdmin: false
      }
    },
    {
      path: '/warehouse/multicart',
      name: 'MultiCartShelfManager',
      component: MultiCartShelfManager,
      meta: {
        requiresAuth: true,
        requiresAdmin: false
      }
    },
    {
      path: '/productiontime',
      name: 'ProductionTime',
      component: ProductionTime
    },
    {
      path: '/cartons',
      name: 'Cartons',
      component: PackagingRoot,
      meta: {
        requiresAuth: true,
        requiresAdmin: false
      }
    },
    {
      path: '/support',
      name: 'Support',
      component: Support,
      props: (route) => ({ search: route.query.search })
    }, 
    {
      path: '/customerSupport',
      name: 'Customer Support',
      component: CustomerSupport
    },
    {
      path: '/zeiterfassung',
      name: 'Zeiterfassung',
      component: TimeTracking
    },
    {
      path: '/barcode',
      name: 'Barcode Generator',
      component: BarcodeGenerator
    },
    {
      path: '/primecutoff',
      name: 'Prime Cut-Off Manager',
      component: PrimeCutOffManager
    },
    {
      path: '/cutoff-monitor',
      name: 'Cutoff Monitor',
      component: CutoffMonitor,
      meta: { requiresAuth: true }
    },
    {
      path: '/packagelist',
      name: 'Paketübergabeliste',
      component: PackageListGenerator
    },
    {
      path: '/inventory',
      name: 'Inventory Worth',
      component: InventoryWorth
    },
    {
      path: '/adminDashboard',
      name: 'Admin Dashboard',
      component: AdminDashboard
    },
    {
      path: '/enhancedDashboard',
      name: 'Orders Dashboard',
      component: EnhancedAdminDashboard
    },
    {
      path: '/importer/muckelmeister',
      name: 'MuckelMeister Importer',
      component: MuckelMeisterImporter
    },
    {
      path: '/importer/etsymuckelmeister',
      name: 'Etsy MuckelMeister Importer',
      component: EtsyMuckelmeisterImporter
    },
    {
      path: '/importer',
      name: 'importer',
      component: ImporterMonitor,
      meta: { requiresAuth: true }
    },
    {
      path: '/shipping-rules',
      name: 'Versandprofilregeln',
      component: ShippingRulesManager,
      meta: { requiresAuth: true }
    },
    {
      path: '/sla-rules',
      name: 'SlaRulesManager',
      component: SlaRulesManager,
      meta: { requiresAuth: true }
    },
    {
      path: '/messages',
      name: 'Nachrichten',
      component: MessageInbox,
      meta: { requiresAuth: true }
    },
    {
      path: '/admin/messages',
      name: 'Admin Nachrichten',
      component: AdminMessageCenter,
      meta: { requiresAuth: true, requiresAdmin: true }
    },
    {
      path: '/admin/packlist-alerts',
      name: 'Packlisten-Warnungen',
      component: PacklistAlertManager,
      meta: { requiresAuth: true, requiresAdmin: true }
    },
    {
      path: '/failed-labels',
      name: 'Failed Labels',
      component: FailedLabels,
      meta: { requiresAuth: true }
    },
    {
      path: '/failed-labels/:orderId',
      name: 'Failed Label Details',
      component: FailedLabelDetails,
      meta: { requiresAuth: true }
    },
    {
      path: '/external-instructions',
      name: 'External Instructions',
      component: ExternalInstructions,
      meta: { requiresAuth: true }
    },
    {
      path: '/user-management',
      name: 'User Management',
      component: UserManagement,
      meta: { requiresAuth: true, requiresAdmin: true }
    },
    {
      path: '/admin/key-assignment',
      name: 'Key Assignment',
      component: KeyAssignment,
      meta: { requiresAuth: true, requiresAdmin: true, allowSmallDevice: true }
    },
    {
      path: '/warehouse/task-choice',
      name: 'Warehouse Task Choice',
      component: WarehouseTaskChoice,
      meta: { requiresAuth: true, allowSmallDevice: true }
    },
    {
      path: '/multicart-wizard',
      name: 'Multicart Wizard',
      component: MulticartWizard,
      meta: { requiresAuth: true, allowSmallDevice: true },
    },
    {
      path: '/embroidery/shelf',
      name: 'Embroidery Shelf Management',
      component: EmbroideryShelf,
      meta: { requiresAuth: true }
    },
    {
      path: '/embroidery/products',
      name: 'Embroidery Products',
      component: EmbroideryProducts,
      meta: { requiresAuth: true }
    },
    {
      path: '/embroidery/exported',
      name: 'Embroidery Exported Items',
      component: () => import('./views/private/embroidery/EmbroideryExportedItems.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/warehouse/embroidery-shelf',
      name: 'Embroidery Shelf Mobile',
      component: () => import('./views/private/warehouse/embroideryShelf/EmbroideryShelfMobile.vue'),
      meta: { requiresAuth: true, allowSmallDevice: true }
    },
    {
      path: '/warehouse/embroidery-label-scan',
      name: 'Embroidery Label Scan',
      component: () => import('./views/private/warehouse/embroideryLabelScan/EmbroideryLabelScan.vue'),
      meta: { requiresAuth: true, allowSmallDevice: true }
    },
    {
      path: '/warehouse/embroidery-stock-in',
      name: 'Embroidery Stock In',
      component: () => import('./views/private/warehouse/embroideryStockIn/EmbroideryStockIn.vue'),
      meta: { requiresAuth: true, allowSmallDevice: true }
    },
    {
      path: '/warehouse/embroidery-post-process',
      name: 'Embroidery Post Process',
      component: () => import('./views/private/warehouse/embroideryPostProcess/EmbroideryPostProcess.vue'),
      meta: { requiresAuth: true, allowSmallDevice: true }
    },
    {
      path: '/warehouse/poster-packing',
      name: 'Poster Packing',
      component: () => import('./views/private/warehouse/posterPacking/PosterPacking.vue'),
      meta: { requiresAuth: true, allowSmallDevice: true }
    },
    {
      path: '/warehouse/place',
      name: 'Warehouse Placement',
      component: MulticartPlacement,
      meta: { requiresAuth: true, allowSmallDevice: true }
    },
    {
      path: '/warehouse/retoure',
      name: 'Mobile Retoure Shelf',
      component: () => import('./views/private/Retoure/MobileRetoureShelf.vue'),
      meta: { requiresAuth: true, allowSmallDevice: true }
    },
    {
      path: '/printer-management',
      name: 'Printer Management',
      component: PrinterManagement,
      meta: {
        requiresAuth: true,
        requiresAdmin: true
      }
    }
  ]
})

// Navigation guard to block small devices from accessing restricted routes
router.beforeEach((to, from, next) => {
  const smallDevice = isSmallDevice();

  // If it's a small device and the route doesn't allow small devices
  if (smallDevice && to.meta.allowSmallDevice !== true) {
    console.warn('⚠️ Small device trying to access restricted route:', to.path);

    // If user is authenticated, redirect to task choice
    // Otherwise redirect to login
    if (to.meta.requiresAuth) {
      next('/warehouse/task-choice');
    } else {
      next('/auth/login');
    }
  } else {
    next();
  }
})

export default router
